import loadable from '@loadable/component';

export const LazyThanksForRsvp = loadable(() => import(/* webpackChunkName: "content/thanksForRsvp" */ '.'));
